import React, { Fragment, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';

import Input from '@/components/v2/Forms/Input';
import { Button } from '@/components/v2/UI/Button';
import { registerStockNotification } from '@/fetchers/stock';
import { useRouter } from 'next/router';
import { getLangCountry } from '@/helpers/languages';
import { getToken } from '@/helpers/auth';
import { useAlert } from '@/context/AlertProvider';
import { useProductState } from '../store';
import { useSelector } from 'react-redux';
import { IGlobalState } from '@/context/reducer';

const RestockForm = () => {
  const { profile: { email } = {} } = useSelector<IGlobalState, IGlobalState>(
    state => state || {}
  );

  const { variation } = useProductState();
  const alert = useAlert();
  const token = getToken();
  const router = useRouter();
  const { t } = useTranslation();
  const { lang, country } = getLangCountry(router.query);

  const [subscribed, setSubscribed] = useState(false);

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      email: ''
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .matches(
          /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i,
          t('INVALID_EMAIL')
        )
        .required(t('REQUIRED_FIELD'))
    }),
    async onSubmit({ email }) {
      const { sku } = variation!;

      const { error } = await registerStockNotification({
        lang,
        country,
        token,
        sku,
        email,
        url: window.location.href
      });

      if (error) {
        return alert.error(t('GENERIC_ERROR'));
      }

      setSubscribed(true);
    }
  });

  const isInStock =
    variation &&
    Number(variation.stock?.in_stock) === 1 &&
    Number(variation.stock?.stock_quantity) > 0;

  useEffect(() => {
    if (email) {
      formik.setFieldValue('email', email, true);
    }
  }, [email]);

  useEffect(() => {
    setSubscribed(false);
  }, [variation]);

  if (!variation || isInStock) {
    return null;
  }

  return (
    // @andrea rivedere lo stile!?
    <div className="bg-sand-100 space-y-6 p-6 md:p-8 rounded-uyn">
      {subscribed ? (
        <div className="space-y-1">
          <p className="font-bold">{t('RESTOCK.COMPLETED.TITLE')}</p>
          <p className="text-gray-500">{t('RESTOCK.COMPLETED.SUBTITLE')}</p>
        </div>
      ) : (
        <Fragment>
          <div className="space-y-3">
            <h3 className="h5">{t('P_PDP.OVERVIEW.RESTOCK.FORM.TITLE')}</h3>
            <p>{t('P_PDP.OVERVIEW.RESTOCK.FORM.SUBTITLE')}</p>
          </div>

          <form onSubmit={formik.handleSubmit} className="space-y-6">
            <Input
              type="email"
              name="email"
              placeholder={t('MAIL_ADDRESS')}
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.errors.email}
              required
            />

            <Button
              variant="dark"
              className="w-full"
              loading={formik.isSubmitting}
            >
              {t('P_PDP.OVERVIEW.RESTOCK.FORM.SUBSCRIBE')}
            </Button>
          </form>
        </Fragment>
      )}
    </div>
  );
};

export default RestockForm;
